/**
 * Returns whether the given value is a string.
 * @param value
 * @returns {boolean}
 */
export function isString(value) {
    return typeof value === "string" || value instanceof String;
}

/**
 * Returns whether the given value is an object literal.
 * @param value
 * @returns {boolean}
 */
export function isObjectLiteral(value) {
    return value && Object.getPrototypeOf(value) === Object.prototype;
}
